export default {
  catAll: 'All',
  catPurchasing: 'Purchasing',
  catKeyActivation: 'Key activation',
  catAccount: 'Account',
  catBilling: 'Billing',
  catRefunds: 'Refunds',

  eyebrow: 'FAQ',
  eyebrowSubtitle: 'Find answers to common questions',

  heroTitle: 'Frequently asked',
  heroTitleAccent: 'questions',
  heroSubtitle: 'System database accessed. Search for solutions or browse categories below.',
  searchPlaceholder: 'Search database...',
  noResults: 'No results. Try a different search or category.',

  stillNeedHelpTitle: 'Still need help?',
  stillNeedHelpBody: "If your question isn't covered above, reach out and our team will get back to you.",
  contactSupport: 'Contact support',

  q1: 'How do I buy a game key?',
  q1Intro: 'Buying a key on PlayStock is an instant, automated process. Just follow these steps:',
  q1Step1: 'Browse the Catalog and open the game you want.',
  q1Step2: 'Click “Add to cart”, then open your cart.',
  q1Step3: 'Go to checkout and pay with your wallet balance (top up first if needed).',
  q1Step4: 'Once payment clears, the key appears instantly in “My Orders” — reveal it and activate.',

  q2: 'Are the keys region locked?',
  q2A: 'Some keys have regional restrictions. Each product page shows a “Regional Restrictions” notice when a key only activates in certain regions; region-free keys work worldwide. Always check the product page before buying.',

  q3: 'How long does activation take?',
  q3A: 'Delivery is instant — the moment your payment clears, the key is available in My Orders. Activating it on the platform (Steam, Epic, etc.) usually takes under a minute.',

  q4: 'How do I activate my key?',
  q4A: 'Open My Orders, reveal the key, then redeem it in the matching platform client (e.g. Steam → Games → Activate a Product). Each order includes step-by-step activation instructions.',

  q5: 'How do I top up my wallet?',
  q5A: 'Go to your Dashboard or Checkout and click “Top up”. Choose an amount and pay via the hosted checkout; your wallet balance updates as soon as the payment is confirmed.',

  q6: 'How do I verify my email?',
  q6A: 'After signing up we email you a verification link. Click it to verify your address — this unlocks purchases up to €50. You can resend it from your Dashboard if needed.',

  q7: 'Can I delete my account?',
  q7A: 'Yes. In Account Settings → Danger Zone you can schedule deletion. Your account is removed after a 7-day grace period, and you can cancel anytime before then.',

  q8: 'What is the refund policy?',
  q8A: 'Unrevealed keys can be refunded. Once a key has been revealed or activated it cannot be refunded, since digital keys are non-recoverable. Contact support if something went wrong with your order.',
};
